import Alert from "../../../../src/components/Alert";
import Task from "../../../../src/components/Task";
import getStaticUrl from "../../../../src/utils/getStaticUrl";
import * as React from 'react';
export default {
  Alert,
  Task,
  getStaticUrl,
  React
};